import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/heroes';
import { movies } from '@/mocks/movies';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 6000);
    return () => clearInterval(timer);
  }, [total]);

  const goPrev = () => setActive((prev) => (prev - 1 + total) % total);
  const goNext = () => setActive((prev) => (prev + 1) % total);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden bg-primary-950">
      {heroSlides.map((slide, index) => {
        const movie = movies.find((item) => item.id === slide.movieId);
        return (
          <div
            key={slide.movieId}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
          >
            <img
              src={slide.image}
              alt={movie ? `${movie.title} 宣传大图` : '影视宣传大图'}
              title={movie ? `${movie.title} 高清影视在线观看` : '影视在线观看'}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/55 to-primary-950/20"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/30"></div>

            {movie && (
              <div className="absolute inset-0 flex items-center">
                <div className="w-full px-4 md:px-6 lg:px-10">
                  <div className="max-w-2xl">
                    <div
                      className={`transition-all duration-700 ${
                        index === active ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
                      }`}
                    >
                      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
                        <i className="ri-fire-fill"></i>
                        热门推荐
                      </span>
                      <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 leading-tight">
                        {movie.title}
                      </h1>
                      <p className="mt-3 text-sm md:text-base text-background-100/90 max-w-xl">
                        {slide.tagline}
                      </p>
                      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs md:text-sm text-background-200">
                        <span className="flex items-center gap-1 text-accent-400 font-semibold">
                          <i className="ri-star-fill"></i>
                          {movie.rating.toFixed(1)}
                        </span>
                        <span>{movie.year}</span>
                        <span>{movie.region}</span>
                        <span>{movie.type}</span>
                        <span className="hidden sm:inline">{movie.genres.join(' / ')}</span>
                      </div>
                      <p className="mt-4 text-xs md:text-sm text-background-200/85 max-w-xl line-clamp-2 md:line-clamp-3">
                        {movie.description}
                      </p>
                      <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                        <Link
                          to={`/detail/${movie.id}`}
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-play-fill"></i>
                          查看详情
                        </Link>
                        <Link
                          to={`/category/${movie.type === '电影' ? 'movie' : movie.type === '电视剧' ? 'tv' : 'variety'}`}
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-layout-grid-line"></i>
                          更多{movie.type}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      <button
        type="button"
        aria-label="上一张"
        onClick={goPrev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 flex items-center justify-center w-9 h-9 md:w-11 md:h-11 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={goNext}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 flex items-center justify-center w-9 h-9 md:w-11 md:h-11 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.movieId}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === active ? 'w-8 bg-accent-500' : 'w-2.5 bg-background-50/50 hover:bg-background-50/80'
            }`}
          />
        ))}
      </div>
    </section>
  );
}